<script lang="ts">
import {defineComponent} from 'vue';
import {PopupTemplate} from '@shared/components/templates';
import {MsToaster} from '@shared/ms-components';
import {useGeneralStore} from "@shared/stores/general.store";
import {mapState} from "pinia";

export default defineComponent({
  name: 'GeneralLayout',
  components: {
    PopupTemplate,
    MsToaster,
  },
  computed: {
    ...mapState(useGeneralStore, ['popup'])
  },
});

</script>

<template>
  <div :class="{'hide': popup.isOpen}" class="app-container">
    <slot></slot>
    <MsToaster />
    <transition name="fade">
      <PopupTemplate v-if="popup.isOpen"/>
    </transition>
  </div>
</template>

<style lang="scss" scoped>

.hide {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
}

</style>
